import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject
} from '@angular/core';
import { PPL_DIALOG_DATA, PplDialogRef } from '@ppl/ui/dialog';
import type { IdentityProviderEntity } from '@ppl/graphql-user-api';

export enum CONFIRM_SPACE_AUTH_DIALOG {
  WITH_DEFAULT_IDP_CHANGE = 'WITH_DEFAULT_IDP_CHANGE',
  WITHOUT_DEFAULT_IDP_CHANGE = 'WITHOUT_DEFAULT_IDP_CHANGE',
}

@Component({
    selector: 'ppl-confirm-additional-space-authorization',
    templateUrl: './confirm-additional-space-authorization.component.html',
    styleUrls: ['./confirm-additional-space-authorization.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ConfirmAdditionalSpaceAuthorizationComponent {
  CONFIRM_SPACE_AUTH_DIALOG = CONFIRM_SPACE_AUTH_DIALOG;

  changeIdpProvider = false;

  get idpName() {
    return this.data.requiredIdp
      ? this.data.requiredIdp.name
      : 'Pipeliner';
  }

  constructor(
    public dialogRef: PplDialogRef<ConfirmAdditionalSpaceAuthorizationComponent>,
    @Inject(PPL_DIALOG_DATA) private data: ConfirmAdditionalSpaceAuthorizationData,
    public changeDetectorRef: ChangeDetectorRef
  ) { }
}

export interface ConfirmAdditionalSpaceAuthorizationData {
  requiredIdp: IdentityProviderEntity | null;
}
